import {
  ControllerRenderProps,
  FieldPath,
  FieldValues,
  MultiSelect,
  MultiSelectOption,
} from '@otp/ui';
import { useMemo } from 'react';
import { useDeviceContext } from 'src/context/device.context';
import { StoreModel } from 'src/graphql/generated/graphql';
import { useStores } from 'src/hooks/query/use-stores';

type StoresProps<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
> = {
  field: ControllerRenderProps<TFieldValues, TName>;
  disabled?: boolean;
  allowSelectAll?: boolean;
  className?: string;
  key?: string;
  storeMap?: (store: Partial<StoreModel>) => MultiSelectOption;
};

export const StoresField = <
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>({
  key,
  field,
  disabled = false,
  allowSelectAll = false,
  className,
  storeMap = (store) => ({
    value: store.id,
    name: '#' + (store.nationalStoreNumber || store.name),
  }),
}: StoresProps<TFieldValues, TName>) => {
  const { stores } = useStores();
  const { isMobile } = useDeviceContext();

  const storeOptions = useMemo(() => stores.map(storeMap), [stores]);

  const defaultStoreValue = field.value;

  return (
    <MultiSelect
      key={key}
      multiple={true}
      fullWidth={true}
      className={className}
      options={storeOptions}
      defaultValue={defaultStoreValue}
      disabled={disabled}
      limitTags={isMobile ? 2 : 3}
      useCheckboxOption={true}
      {...field}
      value={field.value || []}
      ref={undefined}
      allowSelectAll={allowSelectAll}
    />
  );
};
